<section class="main-bg">
    <div class="container py-4 h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="card-body px -5 text-center">
            <h3 class="mb-4" style="color: #fff;
                font-size: 28px;
                font-weight: 300;">
              CREATE ACCOUNT
            </h3>
            <p class="heading-para">Create account by filling below info <span class="mandatory-text">( Fields marked as
                <span class="star">*</span> are required )</span></p>
            <form [formGroup]="createAccountForm" style="
                    width: 100%;
                    padding: 20px;
                    border: none;
                    border-radius: 2px;
                    font-size: 16px;
                    font-weight: 400;
                    margin-bottom: 10px;
                  " (keydown)="checkCapsLock($event)" (keyup)="checkCapsLock($event)" (blur)="capsLockOn = false">
              <div class="form-group">
                <input type="text" id="email" placeholder="Username" class="form-control text-white"
                  formControlName="username" readonly (keydown)="checkCapsLock($event)" (blur)="capsLockOn = false" />
              </div>
              <div class="form-group">
                <input type="text" placeholder="Firstname" class="form-control text-white" formControlName="firstname"
                  name="email" />
              </div>
              <div *ngIf="getErrorMessage('firstname')">
                <small class="error">{{ getErrorMessage('firstname') }}</small>
              </div>
              <div class="form-group">
                <input type="text" placeholder="Lastname" class="form-control text-white" formControlName="lastname"
                  name="email" />
              </div>
              <div *ngIf="getErrorMessage('lastname')">
                <small class="error">{{ getErrorMessage('lastname') }}</small>
              </div>
              <div class="form-group custom-dropdown-container input-group">
                <ng-select class="form-control custom-select text-white unified-input always-show-clear alternate-style"
                  [items]="filteredTimezones" bindLabel="countryName" bindValue="countryName"
                  placeholder="Search Timezone" formControlName="timezone" [searchable]="true" [clearable]="true"
                  [closeOnSelect]="true" [hideSelected]="true" (clear)="onClearTimezone()"
                  (change)="onTimezoneSelected($event)">
                </ng-select>
              </div>
              <div *ngIf="getErrorMessage('timezone')">
                <small class="error">{{ getErrorMessage('timezone') }}</small>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <ng-select
                    class="country-code-select form-control text-white unified-input always-show-clear alternate-style"
                    [items]="countries" bindLabel="countryCode" bindValue="countryCode" placeholder="Search country"
                    formControlName="countryCode" [searchable]="true" [clearable]="true"
                    [ngStyle]="{ 'max-width': '150px' }" [searchFn]="customSearchFn">
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.countryName }} ({{ item.countryCode }})
                    </ng-template>
                  </ng-select>
                  <input type="tel" placeholder="Phone Number" class="form-control text-white unified-input"
                    formControlName="phoneNumber" style="border-top-left-radius: 0; border-bottom-left-radius: 0;" />
                </div>
              </div>
              <div *ngIf="getCombinedErrors(['phoneNumber', 'countryCode'])">
                <small class="error">
                  {{ getCombinedErrors(['phoneNumber', 'countryCode']) }}
                </small>
              </div>
              <div class="form-group">
                <input type="text" placeholder="Streer Address 1" class="form-control text-white"
                  formControlName="streetAddress1" name="email" />
              </div>
              <div *ngIf="getErrorMessage('streetAddress1')">
                <small class="error">{{ getErrorMessage('streetAddress1') }}</small>
              </div>
              <div class="form-group">
                <input type="text" placeholder="Street Address 2" class="form-control text-white"
                  formControlName="streetAddress2" name="email" />
              </div>
              <div *ngIf="getErrorMessage('streetAddress2')">
                <small class="error">{{ getErrorMessage('streetAddress2') }}</small>
              </div>
              <div class="form-group">
                <input type="text" placeholder="State/Province" class="form-control text-white"
                  formControlName="stateProvince" name="email" />
              </div>
              <div *ngIf="getErrorMessage('stateProvince')">
                <small class="error">{{ getErrorMessage('stateProvince') }}</small>
              </div>
              <div class="form-group">
                <input type="text" placeholder="city" class="form-control text-white" formControlName="city"
                  name="email" />
              </div>
              <div *ngIf="getErrorMessage('city')">
                <small class="error">{{ getErrorMessage('city') }}</small>
              </div>
              <div class="form-group">
                <input type="text" placeholder="Zip code" class="form-control text-white" formControlName="zipCode"
                  name="email" />
              </div>
              <div *ngIf="getErrorMessage('zipCode')">
                <small class="error">{{ getErrorMessage('zipCode') }}</small>
              </div>
              <div class="form-group" *ngIf="showInstallerReleatedInput">
                <input type="text" placeholder="Customer Number" class="form-control text-white"
                  formControlName="customerNumber" name="email" />
              </div>
              <div *ngIf="getErrorMessage('customerNumber')">
                <small class="error">{{ getErrorMessage('customerNumber') }}</small>
              </div>
              <div class="form-group" *ngIf="showInstallerReleatedInput">
                <input type="text" placeholder="Organisation Name" class="form-control text-white"
                  formControlName="orgName" name="email" />
              </div>
              <div *ngIf="getErrorMessage('orgName')">
                <small class="error">{{ getErrorMessage('orgName') }}</small>
              </div>
              <div class="form-group position-relative">
                <input [type]="showPassword ? 'text' : 'password'" placeholder="Password" class="form-control text-white"
                  formControlName="password" name="password" />
                <fa-icon [icon]="showPassword ? faEyeSlash : faEye" (click)="togglePasswordVisibility('password')"
                  style="position: absolute; right: 20px; top: 12px; cursor: pointer; color: #fff;"></fa-icon>
              </div>
              <div *ngIf="getErrorMessage('password')">
                <small class="error">{{ getErrorMessage('password') }}</small>
              </div>
              <div class="form-group position-relative">
                <input [type]="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm Password"
                  class="form-control text-white" formControlName="confirmPassword" name="password" />
                <fa-icon [icon]="showConfirmPassword ? faEyeSlash : faEye"
                  (click)="togglePasswordVisibility('confirmPassword')"
                  style="position: absolute; right: 20px; top: 12px; cursor: pointer; color: #fff;"></fa-icon>
              </div>
              <div *ngIf="getErrorMessage('confirmPassword')">
                <small class="error">{{ getErrorMessage('confirmPassword') }}</small>
              </div>
              <div *ngIf="capsLockOn" class="caps-warning">
                🔒 Caps Lock is ON
              </div>
              <button class="submit-button" type="submit" (click)="onSubmitButtonTapped()"
                [disabled]="isSubmittingData">
                <ng-container *ngIf="!isSubmittingData; else loading">
                  CREATE ACCOUNT
                </ng-container>
                <ng-template #loading>
                  <span class="spinner-border spinner-border-sm text-light" role="status"></span>
                  <span class="sr-only">Loading...</span>
                </ng-template>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
</section>  